import React, { useMemo } from "react";

import type { INavModuleProps, ILinkListNavModule } from "../../types";

import { List, LinkListItem } from "./elements";

export default function LinkListNavModule({
  linkModifier,
  modifier,
  links,
  span = 1,
}: INavModuleProps<ILinkListNavModule>) {
  const shouldRenderDoubledColumns = useMemo(() => {
    if (modifier) {
      return false;
    }
    return !(links || []).some((link) => link.icon || link.subtitle);
  }, [links, modifier]);
  return (
    <List withDoubledColumns={shouldRenderDoubledColumns} span={span}>
      {(links || []).map((link) => (
        <li key={link._key}>
          <LinkListItem
            link={link}
            modifier={modifier}
            linkModifier={linkModifier}
          />
        </li>
      ))}
    </List>
  );
}
